import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Quotation, QuotationCreate, QuotationFilter } from '../data/quotation';

export function createQuotationService(client: AxiosInstance) {
  return createCrudService<Quotation, QuotationCreate, QuotationFilter>(
    client,
    '/crm/Quotation',
    'id',
  );
}

export type QuotationService = CrudService<Quotation, QuotationCreate, QuotationFilter>;
